<template>
  <fragment>
    <div class="table-wrapper">
      <div class="btn-all" v-if="btn">
        <el-button
          size="98"
          class="export-color"
          @click="handleSelectionDel"
          v-permission:del="$route.meta.permission"
        >
          删除
        </el-button>
        <el-button
          size="98"
          class="d5"
          @click="openExportPop"
          v-permission:export="$route.meta.permission"
        >
          导出
        </el-button>
      </div>
      <el-table
        ref="table"
        v-min-height
        :data="tableData"
        @selection-change="handleSelectionChange"
        :height="tableHeight"
        :header-cell-class-name="styleTable.header"
        :cell-class-name="styleTable.cell"
      >
        <slot :handleDelete="handleDelete" />
      </el-table>
      <Pagination
        ref="pagination"
        v-if="pagination.recordTotal > 1"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal"
        :totalRecord="pagination.recordTotal"
        @handleNextPage="nextPage"
        @handlePrevPage="prevPage"
        @handleJumpPage="jumpPage"
        @handleChangePageSize="changePageSize"
      />
    </div>
    <Export
      ref="excel"
      :funcName="excelProps.func"
      :id="multipleSelection"
      :excelName="excelProps.name"
    />
  </fragment>
</template>
<script>
import tableOpearting from 'mixins/tableOpearting/'

export default {
  name: 'TableComponent',
  mixins: [tableOpearting],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String
    }
  },
  computed: {
    excelProps() {
      switch (this.$route.name) {
        case 'vipLevel':
          return {
            func: 'exportVipLevel',
            name: '会员等级'
          }
        case 'vipList':
          return {
            func: 'exportVip',
            name: '会员列表'
          }
        case 'vipIntegral':
          return {
            func: 'exportVipIntegral',
            name: '会员积分'
          }
        case 'vipRecharge':
          return {
            func: 'exportVipRecharge',
            name: '会员充值'
          }
        case 'vipCheckIn':
          return {
            func: 'exportVipSignPoints',
            name: '会员签到'
          }
        case 'vipCheck':
          return {
            func: 'exportWinmaker',
            name: '会员审核'
          }
        default:
          return {
            func: '',
            name: ''
          }
      }
    }
  },

  methods: {
    /**
     * 请求删除行
     * @param params
     * @returns {Promise}
     */
    delRows(params) {
      const routeName = this.$route.name
      const delTips = () => {
        this.$notify({
          type: 'success',
          message: '删除成功~！'
        })
      }
      switch (routeName) {
        case 'vipList':
          return this.api
            .changeVipStatus({
              id_array: params.id,
              member_status: 3
            })
            .then(() => {
              delTips()
            })
        case 'vipLevel':
          return this.api.delVipLevel({ level_id: params.id }).then(() => {
            delTips()
          })
        case 'vipCheck':
          return this.api.delSommelierItem({ id_array: params.id }).then(() => {
            delTips()
          })
      }
    },
    /**
     * 批量删除
     * @returns {*|Promise}
     * @private
     */
    _multipleDel() {
      const idAll = this.multipleSelection.map(v => {
        return v.id
      })
      return this.delRows({ id: idAll.join(',') })
    },
    /**
     * 调用父组件请求数据函数
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const routeName = this.$route.name
      const condition = vm.$refs.search._returnSearchData()
      switch (routeName) {
        case 'vipList':
          vm._getVipList({
            curpage: newValue,
            pageSize: size,
            ...condition
          })
          break
        case 'addNewCoupon':
          vm._getVipList({
            curpage: newValue,
            pageSize: size,
            ...condition
          })
          break
        case 'vipLevel':
          vm._getVipLevelList({
            curpage: newValue,
            pageSize: size
          })
          break
        case 'vipIntegral':
          if (this.id) {
            vm._getVipIntegralDetails({
              curpage: newValue,
              member_id: this.id,
              pageSize: size,
              ...condition
            })
          } else {
            vm._getVipIntegralList({
              curpage: newValue,
              pageSize: size,
              ...condition
            })
          }
          break
        case 'vipCheck':
          vm._getSommelierList({
            curpage: newValue,
            audit_status: this.id,
            pageSize: size,
            ...condition
          })
          break
        case 'vipCheckIn':
          vm._getSignList({
            curpage: newValue,
            pageSize: size,
            ...condition
          })
          break
        case 'vipRecharge':
          vm._getVipRechargeList({
            curpage: newValue,
            pageSize: size,
            ...condition
          })
          break
      }
    }
  }
}
</script>
